import React, { useEffect } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import { makeStyles } from '@material-ui/core/styles';

import MainTitle from 'on_web/components/shared/Common/MainTitle';
import SplashScreen from 'on_web/components/shared/SplashScreen/SplashScreen';

import { lifestyleIntroAnimation } from 'on_web/assets/imageList';

import { useTranslation } from 'react-i18next';
import { introScreensTimeout } from 'on_web/helpers/constants';

function LifestyleIntro(props) {
  const imgAnimationStyles = makeStyles(() => ({
    shifted: {
      marginLeft: '-80px',
      marginTop: '-20px',
    },
  }));

  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.onWelcome) {
        props.onWelcome();
      }
    }, introScreensTimeout);
    return () => clearTimeout(timer);
  });

  const imgAnimationClasses = imgAnimationStyles();
  const { t } = useTranslation();
  return (
    <div>
      <Header />
      <SplashScreen>
        <MainTitle
          text={t('onboarding.lifestyleSection.lifestyleIntro.mainTitleText')}
          animate={false}
        ></MainTitle>
        <img
          src={lifestyleIntroAnimation}
          alt="intro animation"
          className={imgAnimationClasses.shifted}
        />
      </SplashScreen>
    </div>
  );
}

export default LifestyleIntro;
